import api from './'

export default {
    /**
     * Get payouts
     * @param params
     */
    get(params) {
        return api
            .get(`/payouts`, {
                params: params,
            })
            .then((response) => {
                return response.data
            })
    },

    /**
     * Show a payout
     * @param payoutId
     * @param params
     */
    show(payoutId, params) {
        return api
            .get(`/payouts/${payoutId}`, {
                params: params,
            })
            .then((response) => {
                return response.data
            })
    },

    /**
     * Get list of payout request
     * @param params
     */
    getPayoutRequests(params) {
        return api
            .get(`/payoutRequests`, {
                params: params,
            })
            .then((response) => {
                return response.data
            })
    },

    /**
     * Show a payout request
     * @param payoutRequestId
     * @param params
     */
    showPayoutRequest(payoutRequestId, params) {
        return api
            .get(`/payoutRequests/${payoutRequestId}`, {
                params: params,
            })
            .then((response) => {
                return response.data
            })
    },

    /**
     * Show a payout request from payout
     * @param payoutId
     * @param params
     */
    getPayoutRequestsFromPayout(payoutId, params) {
        return api
            .get(`/payouts/${payoutId}/payoutRequests`, {
                params: params,
            })
            .then((response) => {
                return response.data
            })
    },
}
